import React from "react";

export default function index() {
  return (
    <div>
      <p>404</p>
    </div>
  );
}
